export default "__VITE_ASSET__82kO0C_N__";